import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { RotateCw } from 'lucide-react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {}

const Component = ({ isLoading, onClick, ...props }: Props) => {
  return (
    <Tooltip label="Atualizar">
      <IconButton
        variant="outline"
        aria-label="Atualizar"
        isLoading={isLoading}
        onClick={onClick}
        icon={<Icon as={RotateCw} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
